import { RawRadioGroup } from '@festina-life/ui/forms'
import { useTranslate } from '@festina-life/ui/hooks'

import { useHasAnyDiff } from '../../context/diffPresenceContext'
import {
  type FPlusDiffLayout,
  fplusDiffLayouts,
} from '../../context/fplusDiffLayout'
import { useFPlusDiffLayout } from './useFPlusDiffLayout'

/**
 * Lets a reader choose whether comparisons are read side by side or stacked.
 * The choice is the page's rather than this block's, and it is remembered.
 *
 * It keeps out of the way of a popover that turned out to hold no diffed
 * comparison, where it would offer a choice that changes nothing on screen yet
 * still speaks for every other popover the reader opens. It carries its own
 * place in the header's grid so that keeping out of the way leaves no gap
 * behind.
 */
export const FPlusDiffLayoutControl = () => {
  const translate = useTranslate()
  const { layout, onChangeLayout } = useFPlusDiffLayout()
  const hasAnyDiff = useHasAnyDiff()

  const labels: Record<FPlusDiffLayout, string> = {
    split: translate('diffPopover.layout.split'),
    unified: translate('diffPopover.layout.unified'),
  }

  if (!hasAnyDiff) {
    return null
  }

  return (
    <RawRadioGroup
      className="col-span-2 justify-self-end"
      options={fplusDiffLayouts}
      value={layout}
      onChange={onChangeLayout}
      keyFn={(option) => option}
      renderFn={(option) => labels[option]}
    />
  )
}
